<template>
  <div class="page-container">
    <!-- 顶部导航栏 -->
    <van-nav-bar title="委托单详情" left-arrow @click-left="onClickLeft" right-text="..." @click-right="onClickRight" fixed placeholder />

    <div class="content">
      <!-- 卡片1：委托单基础信息 -->
      <div class="card base-info-card">
        <div class="card-header">
          <h2 class="order-no">{{ form['OrderNo'] }}</h2>
          <!-- 状态标签 -->
          <van-tag :type="getStatusTagType(form['CurStatus'])" class="status-tag">
            {{ form['CurStatus'] }}
          </van-tag>
        </div>

        <div class="company-name">{{ form['CompanyName'] }}</div>

        <div class="meta-info">
          <span>创建时间 {{ formatDate(form['CreateTime']) }}</span>
          <!-- <span class="dot">·</span>
          <span>样品 {{ orderInfo.sampleCount }} 个</span> -->
        </div>
      </div>

      <!-- 卡片2：状态操作指引卡片（根据状态变化） -->
      <div class="card action-card" @click="handleActionClick">
        <div class="action-content">
          <template v-if="form['CurStatus'] === '审核通过'">
            <div class="action-title">委托单审核通过</div>
            <div class="action-desc">
              提醒：您的委托单审核已通过，请寄出样品并更新快递单信息
            </div>
            <div class="action-btn-text">更新快递单信息 ></div>
          </template>

          <template v-else-if="form['CurStatus'] === '待提交'">
            <div class="action-title">委托单待提交</div>
            <div class="action-desc">提醒：您的委托单尚未提交，请完善信息后提交审核</div>
            <div class="action-btn-text">查看并修改委托单 ></div>
          </template>

          <template v-else-if="form['CurStatus'] === '待审核'">
            <div class="action-title">委托单待审核</div>
            <div class="action-desc">提醒：您的委托单已提交，深海正在审核中，请耐心等待</div>
            <div class="action-btn-text">查看委托单详情 ></div>
          </template>

          <template v-else-if="form['CurStatus'] === '审核驳回'">
            <div class="action-title">委托单审核未通过</div>
            <div class="reject-info">
              <div class="reject-reason">原因：{{ form['AuditNoPassReason'] }}</div>
              <div class="audit-time">审核时间：{{ form['AuditTime'] }}</div>
              <div class="action-desc">提醒：请根据未通过原因修改后重新提交</div>
              <div class="action-btn-text">修改并重新提交 ></div>
            </div>
          </template>
        </div>
        <van-icon name="arrow" class="action-arrow" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, Calendar, Field, Icon, Radio, RadioGroup, Button, Popup, Checkbox, Toast, Dialog } from 'vant'
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'OrderDetail',
  data() {
    return {
      _lastInitSig: '',
      form: {
        Id: ''
      },
      // 模拟从接口获取的订单数据
      // 您可以将 status 修改为 'Draft' | 'Pending' | 'Approved' | 'Rejected' 来查看不同效果
      orderInfo: {
        orderNo: 'DIT20260914001',
        status: 'Approved', // 当前状态
        companyName: '南京诚一新能源装备有限公司',
        receiveDate: '2026-09-14',
        sampleCount: 1,
        testCount: 3,
        rejectReason: '样品规格描述不清晰，缺少牌号信息', // Rejected 状态时显示
        auditTime: '2026-09-15 10:30:00' // Rejected 状态时显示
      }
    }
  },
  created() {
    this.initPage()
  },
  /* 关键：keep-alive 缓存后再次激活时触发 */
  activated() {
    this.initPage()
  },
  /* keep-alive 缓存停用时（离开页面）触发，清空标记，保证下次进入重新初始化 */
  deactivated() {
    this._lastInitSig = ''
  },
  beforeRouteUpdate(to, from, next) {
    next()
    this.$nextTick(() => {
      this.initPage()
    })
  },
  methods: {
    initPage() {
      const q = this.$route.query
      const sig = `${q.orderId || ''}`

      // 参数没变就不重复初始化（可选，根据业务调整）
      if (sig === this._lastInitSig) return
      this._lastInitSig = sig

      this.form.Id = q.orderId || ''

      this.getOrderDetail()
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    getOrderDetail() {
      const _that = this
      const postLoading = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '加载中...'
      })

      axios
        .get(window.config.apiUrl + '/api/Public/GetCustomerCommissionOrder', {
          params: {
            id: _that.form.Id
          }
        })
        .then(function(response) {
          postLoading.clear()
          if (response.data.code == 1) {
            _that.form = response.data.data
          } else {
            Toast(response.data.msg)
          }
        })
        .catch(function(error) {
          postLoading.clear()
          Toast('网络错误')
        })
    },

    // 返回上一页
    onClickLeft() {
      this.$router.go(-1)
    },
    // 右上角更多操作
    onClickRight() {
      this.$toast('点击了更多操作')
    },
    // 状态对应的标签颜色
    getStatusTagType(status) {
      const map = {
        待提交: 'default',
        待审核: 'warning',
        审核通过: 'success',
        审核驳回: 'danger'
      }
      return map[status] || 'default'
    },
    // 点击卡片跳转逻辑
    handleActionClick() {
      const { CurStatus, OrderNo, Id } = this.form

      this.$router.push('/addOrders?orderId=' + Id)
    }
  }
}
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  background-color: #f5f7fa;
}

.content {
  padding: 12px;
}

/* 卡片通用样式 */
.card {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* 卡片1：基础信息 */
.base-info-card {
  position: relative;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.order-no {
  font-size: 18px;
  font-weight: 700;
  color: #1f2d3d;
  margin: 0;
  letter-spacing: 0.5px;
}

.status-tag {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.company-name {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
}

.meta-info {
  font-size: 12px;
  color: #909399;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.meta-info .dot {
  margin: 0 6px;
  font-weight: bold;
}

/* 审核驳回时显示的信息 */
.reject-info {
  margin-top: 12px;
  padding: 10px;
  background-color: #fff0f0;
  border-radius: 8px;
  font-size: 13px;
  color: #ee0a24;
}

.reject-reason {
  margin-bottom: 4px;
  font-weight: 500;
}

.audit-time {
  color: #909399;
  font-size: 12px;
}

/* 卡片2：操作卡片 */
.action-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: background-color 0.2s;
}

.action-card:active {
  background-color: #f9f9f9;
}

.action-content {
  flex: 1;
}

.action-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2d3d;
  margin-bottom: 6px;
}

.action-desc {
  font-size: 13px;
  color: #606266;
  line-height: 1.5;
  margin-bottom: 8px;
}

.action-btn-text {
  font-size: 13px;
  color: #2c7be5;
  font-weight: 500;
}

.action-arrow {
  font-size: 16px;
  color: #c0c4cc;
  margin-left: 12px;
}

/* 卡片3：占位内容（对应截图中的灰色图片区域） */
.placeholder-card {
  min-height: 200px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.placeholder-line {
  height: 16px;
  background: #e5e8ef;
  border-radius: 4px;
  width: 100%;
}

.placeholder-line.short {
  width: 60%;
}

.placeholder-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 10px;
}

.grid-item {
  height: 60px;
  background: #f0f2f6;
  border-radius: 6px;
}
</style>
